import { AuthUser, SecurityRoleEnum } from '../generated/graphql';

export const checkForAnyVXRole = (
  authUser: AuthUser | null,
  roles: SecurityRoleEnum[]
) => {
  if (authUser) {
    return (
      authUser?.roles.filter((element) => roles.includes(element)).length > 0
    );
  }

  return false;
};
